module.exports = __webpack_public_path__ + "media/pricing/pricing-plan-header-bg-df65ba44.jpg";